const HidePasswordIcon = ({ className = "", width = 25, height = 24, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      {/* Eye-slash icon path */}
      <path
        d="M8.573 12.194L4.712 8.33297C3.192 9.98997 2.616 11.65 2.606 11.684L2.5 12L2.605 12.316C2.627 12.383 4.921 19 12.554 19C13.483 19 14.329 18.898 15.106 18.727L12.36 15.981C11.3713 15.9325 10.436 15.518 9.73598 14.818C9.03601 14.118 8.62147 13.1827 8.573 12.194ZM12.554 4.99997C10.699 4.99997 9.179 5.40397 7.912 5.99797L4.207 2.29297L2.793 3.70697L20.793 21.707L22.207 20.293L18.909 16.995C21.547 15.042 22.488 12.358 22.502 12.316L22.607 12L22.502 11.684C22.48 11.617 20.187 4.99997 12.554 4.99997ZM14.46 12.546C14.647 11.869 14.488 11.107 13.968 10.586C13.448 10.065 12.685 9.90697 12.008 10.094L10.5 8.58597C11.1181 8.20619 11.8286 8.00348 12.554 7.99997C14.76 7.99997 16.554 9.79397 16.554 12C16.551 12.7253 16.3479 13.4357 15.967 14.053L14.46 12.546Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default HidePasswordIcon;
